import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Container from '../Container';

const defaultProps = {
  cells: 2,
  mdCells: 2,
  direction: 'cols',
  gap: null,
  mdGap: null,
  children: null,
};

const propTypes = {
  cells: PropTypes.number,
  mdCells: PropTypes.number,
  direction: PropTypes.oneOf([
    'cols',
  ]),
  gap: PropTypes.number,
  mdGap: PropTypes.number,
  children: PropTypes.node,
};

const Grid = ({
  cells,
  mdCells,
  direction,
  gap,
  mdGap,
  children,
}) => (
  <Container
    className={classnames(
      'md:grid',
      cells && `lg:grid-${direction}-${cells}`,
      mdCells && `md:grid-${direction}-${mdCells}`,
      gap && `lg:gap-${gap}`,
      mdGap && `md:gap-${mdGap}`,
    )}
  >
    {children}
  </Container>
);

Grid.defaultProps = defaultProps;
Grid.propTypes = propTypes;

export default Grid;
